<template>
  <div class="admin-layout">
    <!-- <slot name="title">app title</slot> -->
    <!-- <hr/> -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'AdminPatch',
};
</script>

<style lang="sass">
.admin-layout
  padding: 20px 0

</style>




// WEBPACK FOOTER //
// AdminPatch.vue?14cf48b8